import './LeadSourcePromo.scss'
import React from 'react'
import OpButton from "common/views/components/OpButton"

const goToAcceleratorPage = () => {
  window.open("https://marketing.realtor.com/accelerator")
}

const LeadSourcePromo = () => {

  return (
    <div className="LeadSourcePromo">
      <h2>How does our ReadyConnect<sup>SM</sup> Lead Accelerator! work?</h2>

      <div className="LeadSourcePromo__sub-title">
        <div>
          Are you generating online leads and still not seeing the conversion and commissions you want?
          <br/>
          We can work your leads and help you turn them into more closed deals!
        </div>

        <div>
          Our ReadyConnect<sup>SM</sup> Lead Accelerator is available to a select number of brokers nationwide.
        </div>
        <div>
          <OpButton onClick={goToAcceleratorPage} bsStyle="hover-blue" large>
            Learn More
          </OpButton>
        </div>
      </div>
    </div>
  )
}

export default LeadSourcePromo
